import { dataFetcher, fileUploader } from 'core/services/requestHandler';   

const getCities = async (data = {}, config = {}) => {
  return dataFetcher('properties/getCities', data, {...config});
};

const getStates = async (data = {}, config = {}) => {
  return dataFetcher('properties/getStates', data, {...config});
};

const savePropertyData = async (data = {}, config = {}) => {
  return dataFetcher('properties/addLibraryData', data, {method: 'POST', ...config});
};

const getLibrariesPendingApproval = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibrariesPendingApproval', data, { ...config});
};

const deleteLibrary = async (data = {}, config = {}) => {
  return dataFetcher('properties/deleteLibrary', data, { ...config});
};

const deleteLibraryFromStage = async (data = {}, config = {}) => {
  return dataFetcher('properties/deleteLibraryFromStage', data, { ...config});
};

const getLibraryDetailsFromStage = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibraryDataFromStage', data, { ...config});
};

const getLibraries = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibraries', data, { ...config});
};

const getLibraryDetails = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibraryData', data, { ...config});
};

const getLibraryPhotoNames = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibraryPhotoNames', data, { ...config});
};

const saveLibraryCoverPhoto = async (data = {}, config = {}) => {
  return fileUploader('properties/saveLibraryCoverPhoto', data, { method: 'POST', ...config});
};

const uploadLibraryPhoto = async (data = {}, config = {}) => {
  return fileUploader('properties/uploadLibraryPhoto', data, { method: 'POST', ...config});
};

const deleteLibraryPhoto = async (data = {}, config = {}) => {
  return dataFetcher('properties/deleteLibraryPhoto', data, { method: 'POST', ...config});
};

const saveLibrary = async (data = {}, config = {}) => {
  return dataFetcher('properties/saveLibrary', data, { method: 'POST', ...config});
};

const getPropertyReviewsByIdAndType = async (data = {}, config = {}) => {
  return dataFetcher('properties/getPropertyReviewsByIdAndType', data, {...config});
};

const getBankNames = async (data = {}, config = {}) => {
  return dataFetcher('properties/getBankNames', data, {...config});
};

const getKYCStatus = async (data = {}, config = {}) => {
  return dataFetcher('getKYCStatus', data, {...config});
};

const getBankDetails = async (data = {}, config = {}) => {
  return dataFetcher('getBankDetails', data, {...config});
};

const getIdType = async (data = {}, config = {}) => {
  return dataFetcher('getIdType', data, {...config});
};
const deleteIDImage = async (data = {}, config = {}, path) => {
  return dataFetcher('id/'+path, data, {method: 'DELETE', ...config});
};

const saveBankDetails = async (data = {}, config = {}) => {
  return dataFetcher('saveBankDetails', data, {method: 'POST', ...config});
};

const updateBankDetails = async (data = {}, config = {}) => {
  return dataFetcher('updateBankDetails', data, {method: 'POST', ...config});
};

const saveId = async (data = {}, config = {}, type='') => {
  return fileUploader('id/'+type, data, {method: 'POST', ...config});
};

export { getCities, getStates, savePropertyData, getLibrariesPendingApproval, deleteLibrary, deleteLibraryFromStage, 
  getLibraryDetails, getLibraryDetailsFromStage, saveLibraryCoverPhoto, uploadLibraryPhoto, getLibraryPhotoNames,
  deleteLibraryPhoto, getLibraries, saveLibrary,getPropertyReviewsByIdAndType, getKYCStatus, getBankDetails, getIdType, 
  saveBankDetails, updateBankDetails, saveId, deleteIDImage, getBankNames
};
